<template>
  <div class="home">
    <!-- <div class="home_1">
        <van-row type="flex" justify="center">
            <van-col span="18" style="font-size: 25px;text-align: center;color: #dcdee0;font-weight: 700;margin-top: 3%;">AI无人直播系统</van-col>
        </van-row>
        <van-row :gutter="20" style="margin-top: 3%;color: #dcdee0;font-size: 14px;line-height: 38px">
            <van-col span="11" offset="2" >AI技术研发+落地运营</van-col>
            <van-col span="11" >AI租赁+市场推广</van-col>
            <van-col span="11" offset="2" style="font-size: 12px;">AI数字软硬包</van-col>
            <van-col span="11" style="font-size: 12px;">AI数字技术支持</van-col>
            <van-col span="11" offset="2" style="font-size: 12px;">直播间代运营</van-col>
            <van-col span="11" style="font-size: 12px;">定制化AI</van-col>
        </van-row>
    </div> -->
     <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item">
        <img :src="item" alt="" />
      </van-swipe-item>
    </van-swipe>
    <van-row :gutter="20" style="margin-top: 5%;color: #dcdee0;font-size: 14px;height: 9%">
            <van-col span="9" offset="2" class="ai_lease" @click="goRecharge">
              <div class="ai_lease_text">算力充值</div>
            </van-col>
            <van-col span="9" offset="2" class="commission" @click="$router.push('/income')">
              <div class="ai_lease_text" style="margin-right: 13%;">佣金</div>
            </van-col>
    </van-row>
    <van-row :gutter="20" style="margin-top: 5%;color: #dcdee0;font-size: 14px;height: 9%">
            <van-col span="6" offset="2" @click="$router.push('/share')">
              <img src="@/assets/img/go_invite.png" alt="" class="home_3" />
              <div style="text-align: center;">去邀请</div>
            </van-col>
            <van-col span="6" offset="1"  @click="$router.push('/company')">
              <img src="@/assets/img/company_in.png" alt="" class="home_3" />
              <div style="text-align: center;">公司介绍</div>
            </van-col>
            <van-col span="6" offset="1" >
              <img src="@/assets/img/team_img.png" alt="" class="home_3" @click="$router.push('/team')" />
              <div style="text-align: center;">团队管理</div>
            </van-col>
    </van-row>
    <div class="notice_title">公告</div>
    <div class="notice_content">
      <div class="text">
        <div class="title">{{message.title}}</div>
        <p class="content">{{ message.message }}</p>
        <div class="footer">{{ message.createTime }}</div>
      </div>
    </div>
    
    <!-- 导航条 -->
    <!-- <van-nav-bar title="首页" fixed /> -->

    <!-- 搜索框 -->
    <!-- <van-search
      readonly
      shape="round"
      background="#f1f1f2"
      placeholder="请在此输入搜索关键词"
      @click="$router.push('/search')"
    /> -->

    <!-- 轮播图 -->
    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <img :src="item.image" alt="" />
      </van-swipe-item>
    </van-swipe> -->

    <!-- 导航 -->
    <!-- <van-grid column-num="4" icon-size="50">
      <van-grid-item
        v-for="item in navList"
        :key="item.imgUrl"
        :icon="item.imgUrl"
        :text="item.text"
        @click="$router.push(item.path)"
      />
    </van-grid> -->

    <!-- 主会场 -->
    <!-- <div class="main">
      <img src="@/assets/main.png" alt="" />
    </div> -->

    <!-- 猜你喜欢 -->
    <!-- <div class="guess">
      <p class="guess-title">—— 猜你喜欢 ——</p>
    </div> -->
  </div>
</template>

<script>

import {getHomeMessage} from "@/api/home";
import { checkStrNotNull } from "@/utils/common.js";
export default {
  name: "HomePage",

  data() {
    return {
     // bannerList: [require('../../assets/img/home_11.png'),], //轮播
      // bannerList: ['http://localhost:8080/shareImg/banner.jpg'],
      // bannerList: ['https://test.wycm51888.com/shareImg/banner.png'],
      bannerList: ['https://pro.wycm51888.com/shareImg/banner.png'],
      message: {},
      userInfo: this.$store.state.user.userInfo,
    };
  },
   created() {

    getHomeMessage().then(resp => {
        this.message = resp.data;
    }).catch(error => {
      console.error("Error fetching banner data:", error);
      this.$toast(resp.msg);
    });


    // getHomeNav().then(resp => {
    //   this.navList = resp.data;
    // })
    // getHomeGoods().then(resp => {
    //   this.proList = resp.data;
    // })
    // const {
    //   data: { pageData },
    // } = await getHomeData();
    // this.bannerList = pageData.items[1].data;
    // this.navList = pageData.items[3].data;
    // this.proList = pageData.items[6].data;
    // console.log(this.bannerList);
  },
  methods: {
    goRecharge() {
      if(!checkStrNotNull(this.userInfo.shareCode) ){
        this.$toast.fail({message: '请完善个人信息的邀请码后再试',duration: 3500})
        return;
      }
      this.$router.push('/rechargeable');
    },
  }
};
</script>

<style lang="less" scoped>
// 主题 padding
.home {
  // padding-top: 100px;
  // padding-bottom: 50px;
  // background: url(@/assets/img/index_bg.png);
  // background-repeat: no-repeat;
  width: 100%;
  height: 100vh;
  background: url(@/assets/img/index_bg.png) no-repeat left center;
  background-size: 100% 100%;
  overflow: hidden;
}
.home_1 {
  margin-top: 5%;
  color: #fff;
  padding: 10px;
  height: 27%;
  width: 92%;
  background: url(@/assets/img/home_1.png) no-repeat left center;
  background-size: 100% 100%;
  margin: auto;
  margin-top: 5%;
}
.ai_lease {
  background: url(@/assets/img/ai_lease.png) no-repeat left center;
  background-size: 100% 100%;
  height: 100%;
  text-align: center;
}
.ai_lease_text{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 4%;
    font-size: 16px;
    font-weight: 700;
}
.commission {
  background: url(@/assets/img/commission.png) no-repeat left center;
  background-size: 100% 100%;
  height: 100%;
  text-align: center;
}

.notice_title {
  background: url(@/assets/img/notice_title_bg.png) no-repeat left center;
  background-size: 100% 100%;
  text-align: center;
  height: 3%;
  width: 95%;
  margin: 0 auto;
  margin-top: 8%;
  color: #dcdee0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
}

.notice_content {
  background: url(@/assets/img/notice_content_bg.png) no-repeat left center;
  background-size: 100% 100%;
  height: 26%;
  width: 95%;
  margin: 0 auto;
  margin-top: 5%;
  color: #dcdee0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice_content .text {
    background-color: rgb(201 255 255 / 27%);
    width: 85%;
    height: 80%;
    border-radius: 20px;
    padding: 10px;
    font-size: 14px;
    position: relative;
}

.home_3 {
  width: 75%;
  display: block;
  margin: 0 auto;
}

// 导航条样式定制
.van-nav-bar {
  z-index: 999;
  background-color: #c21401;
  ::v-deep .van-nav-bar__title {
    color: #fff;
  }
}

// 搜索框样式定制
.van-search {
  position: fixed;
  width: 100%;
  top: 46px;
  z-index: 999;
}

// 分类导航部分
.my-swipe .van-swipe-item {
  height: 185px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  padding: 10px;
  height: 27%;
  margin-top: 5%;

}
.my-swipe .van-swipe-item img {
  width: 100%;
}

// 主会场
.main img {
  display: block;
  width: 100%;
}

// 猜你喜欢
.guess .guess-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
}

// 商品样式
.goods-list {
  background-color: #f6f6f6;
}
.notice_content .title {
    position: absolute;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 2%;
}

.notice_content .content {
    position: absolute;
    font-size: 14px;
    font-weight: 700;
    text-indent: 2em;
    // color: #0b2f63;
    top: 20%;
    word-break: break-word;
    line-height: 25px;
}
.notice_content .footer {
    position: absolute;
    bottom: 7%;
    right: 5%;
    font-size: 14px;
    font-weight: 700;
}

</style>